import { BillingAccount } from "./billing-account.model";


export interface BankAccountModel {
    ID: string;
    AccountNum: string;
    RoutingNum: string;
    Name: string;
    Type: string;
    TypeCode: string;
    EFTFlag: string;
    EFT: boolean;

    BillingAccounts: BillingAccount[];
}

export class BankAccount implements BankAccountModel {
    ID: string = '';
    AccountNum: string = '';
    RoutingNum: string = '';
    Name: string = '';
    Type: string = '';
    TypeCode: string = '';
    EFTFlag: string = '';
    EFT: boolean = false;

    BillingAccounts: BillingAccount[] = [];
}